import * as React from 'react';
import { connection } from 'decentraland-connect';
import { LoginModal as BaseLoginModal } from 'decentraland-ui/dist/components/LoginModal/LoginModal';
import { T, t } from '../../modules/translation/utils';
import { toModalOptionType, toProviderType } from './utils';
export default class LoginModal extends React.PureComponent {
    static defaultProps = {
        isLoading: false
    };
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.hasError && this.props.hasError) {
            this.setState({
                hasError: true
            });
        }
        else if (prevProps.hasError && !this.props.hasError) {
            this.setState({
                hasError: false
            });
        }
    }
    handleOnConnect = (loginType) => {
        const onConnect = this.props.metadata?.onConnect ?? this.props.onConnect;
        const providerType = toProviderType(loginType);
        onConnect(providerType);
    };
    getModalTranslations = () => {
        if (!this.props.hasTranslations) {
            return undefined;
        }
        return {
            title: React.createElement(T, { id: "@dapps.login.modal.title" }),
            subtitle: React.createElement(T, { id: "@dapps.login.modal.subtitle" }),
            error: React.createElement(T, { id: "@dapps.login.modal.error" })
        };
    };
    getOptionTranslations = () => {
        if (!this.props.hasTranslations) {
            return undefined;
        }
        return {
            browser_extension: React.createElement(T, { id: "@dapps.login.option.browser_extension" }),
            email: React.createElement(T, { id: "@dapps.login.option.email" }),
            mobile: React.createElement(T, { id: "@dapps.login.option.mobile" }),
            mobile_and_browser: React.createElement(T, { id: "@dapps.login.option.mobile_and_browser" }),
            metamask_mobile: React.createElement(T, { id: "@dapps.login.option.metamask_mobile" })
        };
    };
    renderLoginModalOption = (providerType) => {
        const loginType = toModalOptionType(providerType);
        return loginType ? (React.createElement(BaseLoginModal.Option, { key: loginType, type: loginType, i18n: this.getOptionTranslations(), onClick: () => this.handleOnConnect(loginType) })) : null;
    };
    render() {
        const { className, isLoading, onClose } = this.props;
        const { hasError } = this.state;
        return (React.createElement(BaseLoginModal, { open: true, className: className, i18n: this.getModalTranslations(), message: React.createElement(T, { id: "@dapps.login.modal.supported_wallets", values: {
                    br: React.createElement("br", null),
                    trezor_link: (React.createElement("a", { href: "https://github.com/trezor/trezor-firmware/pull/1568", target: "_blank", rel: "noopener noreferrer" }, t('@dapps.login.modal.trezor_link')))
                } }), loading: isLoading, hasError: hasError, onClose: onClose }, connection.getAvailableProviders().map(this.renderLoginModalOption)));
    }
}
//# sourceMappingURL=LoginModal.js.map